import { shallowMount } from "@vue/test-utils";
import UsuarioClave from "@/views/UsuarioClave";
import store from "@/store";

describe("UsuarioClave component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(UsuarioClave, { store });
  });

  it("Renders del component UsuarioClave", () => {
    expect(wrapper).toBeDefined();
  });
});
